export default "__VITE_ASSET__b4a83355__"